import React, { createContext, useEffect, useReducer, useState } from "react";
import { getRequest } from "../../api/laravel/public/api";
import { _retrieveData, _storeData } from "../../utils/local-storage";

const getData = async () => {
  try {
    const jsonValue = await _retrieveData("setting");
    return jsonValue ? jsonValue : null;
  } catch (e) {
    // error reading value
  }
};
const INITIAL_STATE = {
  page: null,
  loading: false,
  setting: getData() || null,
  isFetching: false,
  error: false,
};

export const settingContext = createContext(INITIAL_STATE);

export const SettingContextProvider = ({ children }) => {
  // const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);
  const [setting, setSetting] = useState(null);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    initialApi();
    saveSetting();
  }, [setting]);

  const saveSetting = async () => {
    const jsonValue = await _retrieveData("setting");
    setSetting(jsonValue);
  };

  const initialApi = async () => {
    setLoading(true);
    const pageData = await _retrieveData("page_data");
    const { data_r, message, isError, isLoading } = await getRequest(
      `/auth/api/page`
    );
    if (isError && pageData) {
      setPage(pageData);
      setLoading(false);
      return false;
    }
    if (!pageData) {
      setPage(data_r);
      setLoading(false);
    } else {
      setPage(pageData);
      setLoading(false);
    }
    await _storeData(data_r, "page_data");
  };

  const changeSetting = async (mem) => {
    setSetting(mem);
    const jsonValue = await _storeData(mem, "setting");
  };

  return (
    <settingContext.Provider
      value={{
        page: page,
        loading: loading,
        setting: setting,
        changeSetting,
      }}
    >
      {children}
    </settingContext.Provider>
  );
};
